
import _ from 'lodash'
import { getQuickWords } from "@/api/custom.js"
const QuickWords = {
    state: {
        quickwordList: [],
        inputQuickWord: '',

    },
    mutations: {
        SET_INPUT_QUICK_WORD: (state, payload) => {
            console.log('state,payload', state, payload);
            state.inputQuickWord = payload
        },
        SET_QUICK_WORD_LIST: (state, payload) => {
            state.quickwordList = payload
        }
    },
    actions: {
        // 获取快捷用语
        getQuickWordsList: async ({ commit }) => {
            try {
                const { data } = await getQuickWords()
                console.log("%c Line:27 🧀拿到快捷语数据 data", "color:#e41a6a", data);
                if (data) {
                    commit('SET_QUICK_WORD_LIST', data)
                } else {
                    commit('SET_QUICK_WORD_LIST', [])
                }

            } catch (error) {
                commit('SET_QUICK_WORD_LIST', [])
            }
        }
    }
}

export default QuickWords
